<template>
  <div class="editable-cell">
    <div v-if="editable" class="modal-overlay">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="input-container">
            <a-input
              type="textarea"
              v-model="editingValue"
              :maxLength="10"
              @pressEnter="check"
              placeholder="请输入内容"
              class="modal-input"
            />
            <div class="char-counter">{{ editingValue.length }}/10</div>
          </div>
          <div class="button-container">
            <a-button type="primary" @click="check" class="confirm-btn">确定</a-button>
            <a-button @click="cancel" class="cancel-btn">取消</a-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="editable-cell-text-wrapper">
      <a @click="edit" >{{name}}</a>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  created() {
  },
  data() {
    return {
      editable: false,
      editingValue: this.value || ''
    }
  },
  methods: {
    // 确认编辑
    check() {
      this.editable = false;
      this.$emit('submit', this.editingValue);
    },
    // 取消编辑
    cancel() {
      this.editable = false;
      this.editingValue = this.value || '';
    },
    edit() {
      this.editable = true;
      this.editingValue = this.value || '';
    },
  },
  watch: {
    // 监听上级 value 改变
    value(newValue) {
      if (!this.editable) {
        this.editingValue = newValue || '';
      }
    },
  },
  mounted() {
  }
}
</script>
<style scoped>
.editable-cell {
  position: relative;
}

.editable-cell-text-wrapper {
  padding: 5px 5px 5px 28px;
}

.editable-cell-icon {
  position: absolute;
  left: 0;
  width: 24px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
  display: none;
}

.editable-cell:hover .editable-cell-icon {
  display: inline-block;
}

.editable-cell-icon:hover {
  color: #108ee9;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-dialog {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 24px;
  min-width: 400px;
  max-width: 500px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input-container {
  position: relative;
}

.modal-input {
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
}

.modal-input:focus {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.char-counter {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  font-size: 12px;
}

.button-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.confirm-btn {
  background-color: #1890ff;
  border-color: #1890ff;
  color: white;
  padding: 4px 15px;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-btn:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
}

.cancel-btn {
  background-color: white;
  border: 1px solid #d9d9d9;
  color: #333;
  padding: 4px 15px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}

.editable-add-btn {
  margin-bottom: 8px;
}
</style>